import { isDesktopView, scrollIntoView } from '@/shared/utils/dom';

const activeClassName = 'js-active';

export const initProductInfoTabs = () => {
  const tabsContainer = document.querySelector('.js-tabs-container');
  if (!tabsContainer) return;
  const tabButtons = tabsContainer.querySelectorAll('.js-tab-button');

  if (tabButtons.length === 0) return;

  tabButtons.forEach((btn) => {
    btn.addEventListener('click', (e) => {
      e.preventDefault();
      const target = e.target as HTMLButtonElement | null;

      // Scroll into view
      if (target && !isDesktopView()) {
        // Timeout is needed to ensure the tab content is visible before scrolling
        setTimeout(() => {
          scrollIntoView(target);
        }, 0);
      }

      // New active tab + content
      const newTab =
        target && tabsContainer.querySelector(`[name=${target.name}]`);

      const newContent = target
        ? tabsContainer.querySelector(`#${target.name}`)
        : null;

      // "Open/Close same tab" - should only be possible on mobile + tablet
      if (newContent?.classList.contains(activeClassName) && !isDesktopView()) {
        newTab?.classList.remove(activeClassName);
        newContent?.classList.remove(activeClassName);
        return;
      }

      // ... Or close active tag and switch to new tab
      tabsContainer.querySelectorAll(`.${activeClassName}`).forEach((tab) => {
        tab.classList.remove(activeClassName);
      });

      newTab?.classList.add(activeClassName);
      newContent?.classList.add(activeClassName);
    });
  });

  // If all tabs have been closed and user resizes to desktop, activate the first tab
  const ensureActivateTabOnDesktopAfterResize = () => {
    const activeTabs = tabsContainer.querySelectorAll(`.${activeClassName}`);

    if (isDesktopView() && !activeTabs.length) {
      const firstTab = tabsContainer.querySelector('.js-tab-button');
      const firstTabContent = tabsContainer.querySelector('.js-tab-content');

      if (firstTab && firstTabContent) {
        firstTab.classList.add(activeClassName);
        firstTabContent.classList.add(activeClassName);
      }
    }
  };
  window.addEventListener('resize', ensureActivateTabOnDesktopAfterResize);
};
